import Nullstack from 'nullstack';
export default function IconEyeTable({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-eye-table",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8.003 18.003h-.011"
  }), "   ", Nullstack.element("path", {
    d: "M12.003 18.002h-.011"
  }), "   ", Nullstack.element("path", {
    d: "M16.003 18.002h-.011"
  }), "   ", Nullstack.element("path", {
    d: "M4 3h16"
  }), "   ", Nullstack.element("path", {
    d: "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17"
  }), "   ", Nullstack.element("path", {
    d: "M14 7h-4"
  }), "   ", Nullstack.element("path", {
    d: "M9 15h1"
  }), "   ", Nullstack.element("path", {
    d: "M14 15h1"
  }), "   ", Nullstack.element("path", {
    d: "M12 11v-4"
  }), " ");
}